const Loader = {
	_modules: {},
	register (name, module) {
		this._modules[name] = module;
	},
	import (name) {
		return Loader.loadLibs().then(() => Loader._modules[name]());
	},
	asyncProxy (name, ...args) {
		return Loader.import(name).then((module) => new module(...args));
	},
	loadLibs () {
		return Promise.resolve()
	}
};

const modules = {
	LeaderboardTickerControl: () => {
		return import('./modules/leaderboard-ticker/leaderboard-ticker')
			.then(module => module.LeaderboardTickerControl)
	},
	Gallery: () => {
		return import('./modules/gallery/gallery').then((module) => module.Gallery)
	}
};

window.usga = window.usga || {};
const usga = window.usga;

for (const moduleName in modules) {
	Loader.register(moduleName, modules[moduleName]);
	usga[moduleName] = Loader.asyncProxy.bind(Loader, moduleName);
}
